<template>
  <DialogComponent
    @submit="onSubmit"
    :title="this.title"
  >
    <form @submit="onSubmit">
      <b-form-group
        id="campanyName"
        label="Company name:"
        label-for="campanyName"
      >
        <input
          id="campanyName"
          type="text"
          v-model.trim="company.companyName"
          placeholder="Enter company name"
          v-validate="'required'"
          data-vv-as="Company Name"
          name="companyName"
          class="form-control"
          :class="{'is-invalid': errors.has('companyName')}"
          autofocus
        />
        <span
          v-show="errors.has('companyName')"
          class="error-message"
        >
          {{ errors.first('companyName') }}
        </span>
      </b-form-group>
      <b-form-group
        id="currency"
        label="Currency:"
        label-for="currency"
      >
        <select v-model="company.currency"
                id="currency"
                class="form-control"
                name="currency"
                data-vv-as="Currency"
                v-validate="'required'"
                :class="{'is-invalid': errors.has('currency')}">
          <option selected disabled value="">Select currency</option>
          <option v-for="curr of currencies"
                  :key="curr.id"
                  :value="+curr.id">{{curr.name}}</option>
        </select>
        <span
          v-show="errors.has('currency')"
          class="error-message"
        >
          {{ errors.first('currency') }}
        </span>
      </b-form-group>
      <b-form-group
        id="description"
        label="Description:"
        label-for="description"
      >
        <b-form-textarea
          v-model="company.description"
          placeholder="Enter description"
          :rows="3"
          :max-rows="6"
        >
        </b-form-textarea>
      </b-form-group>
      <b-form-group
        id="status"
      >
        <div class="form-group">
          <label>Status</label>
          <switches v-model="company.status" color="green"></switches>
        </div>
      </b-form-group>
    </form>
  </DialogComponent>
</template>

<script>
import Switches from 'vue-switches';
import omit from 'lodash/omit';
import DialogComponent from '@/components/Dialog';

import COMPANY from '@/graphql/Companies/Company.gql';
import CREATE_COMPANY from '@/graphql/Companies/CreateCompany.gql';
import EDIT_COMPANY from '@/graphql/Companies/EditCompany.gql';
import CURRENCIES from '@/graphql/Currencies/Currencies.gql';
import ModalMixin from '@/mixins/ModalMixin';

export default {
  name: 'edit-company-component',
  mixins: [ModalMixin],
  components: {
    Switches,
    DialogComponent,
  },
  props: {
    id: String,
  },

  data() {
    return {
      company: {
        companyName: '',
        description: '',
        currency: 1,
        status: true,
      },
      currencies: [],
    };
  },
  computed: {
    title() {
      return `${this.id ? 'Update' : 'Create'} Company`;
    },
  },
  methods: {
    async onSubmit() {
      try {
        const valid = await this.$validator.validateAll();
        if (!valid) {
          return;
        }
      } catch (e) {
        return;
      }

      this.$apollo
        .mutate({
          mutation: this.id ? EDIT_COMPANY : CREATE_COMPANY,
          variables: {
            id: parseInt(this.id),
            input: omit(this.company, ['id']),
          },
          refetchQueries: ({ data }) => {
            const response = data.createCompany || data.updateCompany;
            return response && response.success ? ['companies'] : [];
          },
        })
        .then(() => {
          this.$notify({
            group: 'success',
            type: 'success',
            text: `Company was ${this.id ? 'edited' : 'created'}`,
          });
          this.close();
        })
        .catch(e => {
          if (e.message.includes('ER_DUP_ENTRY')) {
            this.$validator.errors.add('companyName', 'This Company Name already exists');
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              text: e.message,
            });
          }
        });
    },
  },
  apollo: {
    company: {
      query: COMPANY,
      fetchPolicy: 'cache-and-network',
      variables() {
        return {
          id: +this.id,
        };
      },
      result({ data, loading }) {
        if (!loading) {
          this.company = {
            companyName: data.company.companyName,
            description: data.company.description,
            status: data.company.status,
          };
        }
      },
      skip() {
        return !this.id;
      },
    },

    currencies: {
      query: CURRENCIES,
      fetchPolicy: 'cache-and-network',
      result({ data, loading }) {
        if (!loading) {
          this.currencies = data.currencies;
        }
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.checkboxes-wrapper {
  max-height: 378px;
  overflow: auto;

  .form-check {
    border-top: 1px solid #c1c1c1;
    padding-top: 0.4rem;
    margin-bottom: 0.4rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/modals/EditCompanyModal.vue